import { useState, useCallback } from 'react';

const KEY = 'sv_recently_viewed';
const MAX = 5;

export function useRecentlyViewed() {
  const [items, setItems] = useState(() => {
    try {
      const stored = localStorage.getItem(KEY);
      return stored ? JSON.parse(stored) : [];
    } catch { return []; }
  });

  const trackViewed = useCallback((sag) => {
    if (!sag?.id) return;
    setItems(prev => {
      const filtered = prev.filter(s => s.id !== sag.id);
      const updated = [
        { id: sag.id, sagsnummer: sag.sagsnummer, klient: sag.klient, type: sag.type, ts: Date.now() },
        ...filtered,
      ].slice(0, MAX);
      try { localStorage.setItem(KEY, JSON.stringify(updated)); } catch {}
      return updated;
    });
  }, []);

  return { recentlyViewed: items, trackViewed };
}
